module.exports = __webpack_public_path__ + "static/media/charlie-chamero-md.7efab81a.mp4";